import { render } from "./show.vue?vue&type=template&id=54519213&scoped=true&ts=true"
import script from "./show.vue?vue&type=script&lang=ts"
export * from "./show.vue?vue&type=script&lang=ts"

import "./show.vue?vue&type=style&index=0&id=54519213&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54519213"]])

export default __exports__